import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const startSession = (source) => axios.post(`${API}/sessions/start`, { source });

export const completeSession = (payload) => axios.post(`${API}/sessions/complete`, payload);

export const submitLead = (payload) => axios.post(`${API}/leads`, payload);

export const adminLogin = (password) => axios.post(`${API}/admin/login`, { password });

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

const filterParams = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => v && p.set(k, v));
  const s = p.toString();
  return s ? `?${s}` : "";
};

export const getStats = (token, filters = {}) =>
  axios.get(`${API}/admin/stats${filterParams(filters)}`, { headers: authHeaders(token) });

export const downloadCsv = async (token, filters = {}, kind = "sessions") => {
  const path = kind === "leads" ? "export-leads" : "export";
  const res = await axios.get(`${API}/admin/${path}${filterParams(filters)}`, {
    headers: authHeaders(token),
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = kind === "leads" ? "lacrime-di-coccodrillo-lead.csv" : "lacrime-di-coccodrillo-sessioni.csv";
  a.click();
  URL.revokeObjectURL(url);
};
